import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { allowLanguage } from "helpers";
import en from 'locales/en';
import ja from 'locales/ja';
import th from 'locales/th';
import zh from 'locales/zh';
import zhTW from 'locales/zh-TW';
import vi from 'locales/vi';

const lang = allowLanguage();
document.documentElement.lang = lang;

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .on('languageChanged', (lng, ns, msg) => {
        document.title = i18n.t(`아프리카TV | 투표`);
    })
    .init(
        {
            lng: lang,
            debug: false,
            keySeparator: false, // we do not use keys in form messages.welcome
            fallbackLng: "ko",
            react: {
                useSuspense: false,
			},
			nsSeparator : false, // char to split namespace from key ex) 1:1 투표
            resources: {
                en: { translation: en.lang },
                ja: { translation: ja.lang },
                th: { translation: th.lang },
                zh: { translation: zh.lang },
                'zh-TW': { translation: zhTW.lang },
                vi: { translation: vi.lang },
            }
        },
    );

export default i18n;
